import { useState, useRef } from "react";
import styled from "styled-components";

import punteroArrowLeft from "../../img/puntero/LeftArrow.png";
import punteroArrowRight from "../../img/puntero/RightArrow.png";
import playBT from "../../img/puntero/playBt.png";
import cruzBlack from "../../img/puntero/cruzFB.png";
import cruzWhite from "../../img/puntero/cruzFW.png";

import { VideoVimeoComponent } from "../../components/VideoVimeoComponent";
import { LazyGalleryImage } from "./LazyImage";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "../../hooks/MediaQueryhook";
import punteroImgLink from "../../img/puntero/CaseStudy.png"; 

// --- Styled Components ---

const GalleryContainer = styled.div`
  display: grid;
  width: auto; 
  margin: 0;
  gap: 10px;
  @media (min-width: 769px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const CardWrapper = styled.div`
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  background-color: #ffffff;
`;

const FullScreen = styled.div`
  width: 100vw;
  height: 100vh;
  z-index: 62;
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #ffffff;
`;

const ImgFullScreen = styled.div`
  z-index: 63;
  width: 80%;
  height: 100%;
  position: fixed;
  top: 0; left: 10%;
  display: grid;
`;

const VideoFullScreen = styled.div`
  width: 80%;
  height: 100vh;
  z-index: 63;
  position: fixed;
  top: 0; left: 10%;
  display: flex;
`;

const VideoFullWrapper = styled.div`
  z-index: 64;
  width: 80%;
  height: auto;
  align-self: center;
  position: fixed;
  left: 10%;
  display: grid;
`;

const NavigationMask = styled.div`
  height: 100%;
  width: 100%;
  grid-row-start: 1;
  grid-column-start: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  z-index: 10;
`;

const BtLeft = styled.div`
  cursor: url(${punteroArrowLeft}), auto;
  grid-column-start: 1;
`;

const BtRight = styled.div`
  cursor: url(${punteroArrowRight}), auto;
  grid-column-start: 3;
`;

const ImgWrapper = styled.div`
  grid-column-start: 1;
  grid-row-start: 1;
`;

const VideoThumbnail = styled.div`
  display: grid;
`;



const VideoThumbnailMask = styled.div`
  opacity: 0.8;
  height: 100%;
  width: 100%;
  grid-row-start: 1;
  grid-column-start: 1;
  cursor: pointer;
  background: url(${playBT}) center/contain no-repeat rgba(0, 0, 0, 0);
  background-size: 10%;
  transition: opacity 0.3s ease; 
  &:hover {
    opacity: 0;
  }
`;

const HoverVideoElement = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 5;
  pointer-events: none; 
  animation: fadeInHover 0.4s ease-in-out;

  @keyframes fadeInHover {
    from { opacity: 0; }
    to { opacity: 1; }
`;

const ContainerNavBar = styled.div`
  z-index: 200;
  position: fixed;
  top: 0; right: 0;
  height: 0;
  width: 50vw;
  display: grid;
  @media screen and (max-width: 768px) { width: 100vw; }
`;

const ContenedorClose = styled.div`
  margin-top: 2.5vw;
  grid-column: 1;
  justify-self: end;
  padding-right: 2.5vw;
`;

const Circle = styled.div`
  background-image: url(${({ isHovered }) => isHovered ? cruzWhite : cruzBlack});
  background-size: 40%;
  background-position: 50%;
  background-repeat: no-repeat;
  height: 50px;
  width: 50px;
  border-radius: 50px;
  transition: all 0.1s linear;
  background-color: ${({ isHovered }) => (isHovered ? "black" : "white")};
  cursor: pointer;
`;

const CargaImagenes = ({ images = [] }) => {
  // 1. States
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const navigate = useNavigate();
  const videoRefs = useRef({});
  const isMediaQueryMayor769px = useMediaQuery("(min-width: 769px)");

  // 2. Handlers
const handleImageClick = (index) => {
    const item = images[index];

    // Check if the item has a link and is an image (Vimeo videos won't navigate)
    if (item?.tipo === "image" && item?.link) {
      navigate(item.link); // Redirects to /work/FO
    } else {
      // Fallback: Opens the viewer for videos or images without links
      setSelectedImageIndex(index);
      setIsViewerOpen(true);
    }
  };

  const handleViewerClose = () => {
    setIsViewerOpen(false);
    setSelectedImageIndex(null);
  };

  const handleNavigation = (e, offset) => {
    e.stopPropagation();
    if (images.length === 0) return;
    setSelectedImageIndex((prevIndex) => 
      (prevIndex + offset + images.length) % images.length
    );
  };

  // 3. Column Logic (Fixes the "leftColumn is not defined" error)
  const leftColumn = [];
  const rightColumn = [];

  images.forEach((item, index) => {
    // We attach the globalIndex so it's always available for handleImageClick
    const itemWithIndex = { ...item, globalIndex: index };
    
    if (!isMediaQueryMayor769px) {
      leftColumn.push(itemWithIndex);
    } else {
      if (index % 2 === 0) {
        leftColumn.push(itemWithIndex);
      } else {
        rightColumn.push(itemWithIndex);
      }
    }
  });

  const columnGroups = isMediaQueryMayor769px ? [leftColumn, rightColumn] : [leftColumn];

  // 4. Early return if no images
  if (!images || images.length === 0) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  return (
    <GalleryContainer>
      {columnGroups.map((columnImages, colIdx) => (
        <Column key={`col-${colIdx}`}>
          {columnImages.map((item) => (
            <CardWrapper 
              key={`card-${item.globalIndex}`}
              onMouseEnter={() => setHoveredIndex(item.globalIndex)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{ 
    position: 'relative', 
    cursor: (isMediaQueryMayor769px && item.link)
      ? `url("${punteroImgLink}"), pointer` // Note the double quotes inside the url("")
      : "auto" 
  }}
              
            >
              <div className="zoom-target" style={{ width: '100%', height: '100%', display: 'grid', position: 'relative' }}>
                {item.tipo === "image" ? (
                  <>
<LazyGalleryImage
  src={item.small}
  alt=""
  style={{
    cursor: isMediaQueryMayor769px 
      ? (item.link ? `url(${punteroImgLink}), pointer` : "zoom-in") 
      : "pointer",
  }}
  onClick={() => isMediaQueryMayor769px && handleImageClick(item.globalIndex)}
/>

{item.hoverVideo && hoveredIndex === item.globalIndex && (
  <HoverVideoElement 
    src={item.hoverVideo} 
    autoPlay 
    loop 
    muted 
    playsInline 
    /* Add the cursor style here too! */
    style={{
      cursor: isMediaQueryMayor769px 
        ? (item.link ? `url(${punteroImgLink}), pointer` : "zoom-in") 
        : "pointer",
    }}
  />
)}
                  </>
                ) : (
                  <VideoThumbnail>
                    <VideoVimeoComponent
                      url={item.big}
                      fullScreen={false}
                      videoId={item.globalIndex}
                      videoRefs={videoRefs}
                    />
<VideoThumbnailMask
  onMouseEnter={() => {
    const playPromise = videoRefs.current[item.globalIndex]?.playVideo();
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        // Auto-play was prevented or interrupted
        console.log("Playback prevented");
      });
    }
  }}
  onMouseLeave={() => {
    // A small delay or check here prevents the interrupt crash
    videoRefs.current[item.globalIndex]?.pauseVideo();
  }}
  onClick={() => isMediaQueryMayor769px && handleImageClick(item.globalIndex)}
/>
                  </VideoThumbnail>
                )}
              </div>
            </CardWrapper>
          ))}
        </Column>
      ))}

      {/* Fullscreen Viewer */}
      {isViewerOpen && selectedImageIndex !== null && images[selectedImageIndex] && (
        <>
          <FullScreen onClick={handleViewerClose}>
            <ContainerNavBar>
              <ContenedorClose>
                <Circle
                  isHovered={isHovered}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  onClick={handleViewerClose}
                />
              </ContenedorClose>
            </ContainerNavBar>
          </FullScreen>

          {images[selectedImageIndex].tipo === "image" ? (
            <ImgFullScreen>
              <ImgWrapper
                style={{
                  backgroundImage: `url(${images[selectedImageIndex].big})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat",
                  height: "100%"
                }}
              />
              <NavigationMask>
                <BtLeft onClick={(e) => handleNavigation(e, -1)} />
                <div />
                <BtRight onClick={(e) => handleNavigation(e, 1)} />
              </NavigationMask>
            </ImgFullScreen>
          ) : (
            <VideoFullScreen>
              <VideoFullWrapper>
                <VideoVimeoComponent
                  key={selectedImageIndex}
                  url={images[selectedImageIndex].big}
                  fullScreen={true}
                />
                <NavigationMask>
                  <BtLeft onClick={(e) => handleNavigation(e, -1)} />
                  <div />
                  <BtRight onClick={(e) => handleNavigation(e, 1)} />
                </NavigationMask>
              </VideoFullWrapper>
            </VideoFullScreen>
          )}
        </>
      )}
    </GalleryContainer>
  );
};
export default CargaImagenes;